export default __webpack_public_path__ + "static/media/fair-200.734d96df.png";